export default __webpack_public_path__ + "static/media/facebookIcon.a879d2b1.svg";